import React, { Fragment, Component } from 'react';
import { FormGroup, Row, Label, Input, Col, Button } from 'reactstrap';
import Drawer from 'react-motion-drawer';
import Hamburger from 'react-hamburgers';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Switch from "react-switch";
import IMG01 from '../../../assets/DVTools/images/ChannelMediaThumbs/Video-Icon.png';
import helnix_default_logo from '../../../assets/DVTools/images/default_player.jpg';
import * as SaveSettingsUtils from '../js/save_settings';
import { toast, Slide } from 'react-toastify';
export default class ModalDrawer extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            FirstName: "test",
            videoDesignSettingDiv: this.props.videoDesignSettingDiv,
            videoData: this.props.videoData,
            ToastMessage: "All good",
            ToastAlertType: "info",
            openRight: this.props.isOpened,
        }
        this.handleVideoLogoChange = this.handleVideoLogoChange.bind(this);
        this.onLogoChange = this.onLogoChange.bind(this);
    }
    showToast = (msg, AlertType) =>
    {
        this.toastId = toast(msg, {
            transition: Slide,
            closeButton: true,
            autoClose: 5000,
            position: 'bottom-center',
            type: AlertType,
        });
    }
    componentWillReceiveProps(nextProps)
    {
        if (nextProps.isOpened === true && this.state.videoDesignSettingDiv.show_logo === undefined)
        {
            this.setState({ videoDesignSettingDiv: nextProps.videoDesignSettingDiv })
        }
        if (nextProps.isOpened !== this.state.openRight)
        {
            this.setState({ openRight: nextProps.isOpened })
        }
    }
    onLogoChange = (e) =>
    {
        var checked = e;

        this.setState(prevState => ({
            videoDesignSettingDiv: {
                ...prevState.videoDesignSettingDiv,
                show_logo: checked
            }
        }), () =>
        {
            this.props.onChangeSetting(this.state.videoDesignSettingDiv);
        })

    }
    onHomePageChange = (e) =>
    {
        var checked = e;

        this.setState(prevState => ({
            videoDesignSettingDiv: {
                ...prevState.videoDesignSettingDiv,
                show_homepage: checked
            }
        }), () =>
        {
            this.props.onChangeSetting(this.state.videoDesignSettingDiv);
        })

    }
    onReferncesChange = (e) =>
    {
        var checked = e;

        this.setState(prevState => ({
            videoDesignSettingDiv: {
                ...prevState.videoDesignSettingDiv,
                show_references: checked
            }
        }), () =>
        {
            this.props.onChangeSetting(this.state.videoDesignSettingDiv);
        })

    }
    onBookmarksChange = (e) =>
    {
        var checked = e;

        this.setState(prevState => ({
            videoDesignSettingDiv: {
                ...prevState.videoDesignSettingDiv,
                show_bookmarks: checked
            }
        }), () =>
        {
            this.props.onChangeSetting(this.state.videoDesignSettingDiv);
        })

    }
    onChatChange = (e) =>
    {
        var checked = e;

        this.setState(prevState => ({
            videoDesignSettingDiv: {
                ...prevState.videoDesignSettingDiv,
                show_chat: checked
            }
        }), () =>
        {
            this.props.onChangeSetting(this.state.videoDesignSettingDiv);
        })

    }
    onDownloadChange = (e) =>
    {
        var checked = e;

        this.setState(prevState => ({
            videoDesignSettingDiv: {
                ...prevState.videoDesignSettingDiv,
                show_download: checked
            }
        }), () =>
        {
            this.props.onChangeSetting(this.state.videoDesignSettingDiv);
        })

    }
    onCommentsChange = (e) =>
    {
        var checked = e;

        this.setState(prevState => ({
            videoDesignSettingDiv: {
                ...prevState.videoDesignSettingDiv,
                show_comments: checked
            }
        }), () =>
        {
            this.props.onChangeSetting(this.state.videoDesignSettingDiv);
        })

    }
    onFacebookCommentsChange = (e) =>
    {
        var checked = e;
        this.setState(prevState => ({
            videoDesignSettingDiv: {
                ...prevState.videoDesignSettingDiv,
                show_fb_comments: checked
            }
        }), () =>
        {
            this.props.onChangeSetting(this.state.videoDesignSettingDiv);
        })

    }
    handleUploadChannelLogo = (e) =>
    {
        this.logoInputElement.click();
    }
    onLogoImageError = () =>
    {
        //if (this.props.customAccountInfo !== null)
        //{
        //    this.imgLogo.src = IMG01;
        //}
        //else
        {
            this.imgLogo.src = "";
            this.setState(prevState => ({
                videoDesignSettingDiv: {
                    ...prevState.videoDesignSettingDiv,
                    logo_src: "",
                }
            }), () =>
            {
                this.props.onChangeSetting(this.state.videoDesignSettingDiv);
            });
        }
    }
    handleCancelVideoLogoUpload = () =>
    {
        //var logo_src = IMG01;
        //if (this.props.customAccountInfo === null)
        //{
        var logo_src = "";
        //}
        //else if (this.props.customAccountInfo.brand_logo !== null && this.props.customAccountInfo.brand_logo !== undefined && this.props.customAccountInfo.brand_logo!=="")
        //{
        //    logo_src = this.props.customAccountInfo.brand_logo
        //}
        this.setState(prevState => ({
            videoDesignSettingDiv: {
                ...prevState.videoDesignSettingDiv,
                logo_src: logo_src,
                videoLogoFile: "",
                logo_guid: "none",
            }
        }), () =>
        {
            this.props.onChangeSetting(this.state.videoDesignSettingDiv);
        })
    }
    handleVideoLogoChange(e)
    {
        var logo_file = e.target.files[0];
        e.preventDefault();
        let reader = new FileReader();
        this.setState(prevState => ({
            videoDesignSettingDiv: {
                ...prevState.videoDesignSettingDiv,
                videoLogoFile: logo_file,
                logo_guid: logo_file.name
            }
        }), () =>
        {
            reader.onloadend = () =>
            {
                this.setState(prevState => ({
                    videoDesignSettingDiv: {
                        ...prevState.videoDesignSettingDiv,
                        logo_src: reader.result,
                        videoLogo: reader.result
                    }
                }), () =>
                {
                    this.props.onChangeSetting(this.state.videoDesignSettingDiv);
                });
            }
            reader.readAsDataURL(this.state.videoDesignSettingDiv.videoLogoFile)
        })
    }
    onSaveVideoSettingsClick = () =>
    {
        SaveSettingsUtils.update_settings(this);
    }
    onHomePageTextChange = (e) =>
    {
        var text = e.currentTarget.value;
        this.setState(prevState => ({
            videoDesignSettingDiv: {
                ...prevState.videoDesignSettingDiv,
                homepage_link: text,
            }
        }))
        this.props.onChangeSetting(this.state.videoDesignSettingDiv)
    }
    onThemeChange = (e) =>
    {
        var checked = e;

        this.setState(prevState => ({
            videoDesignSettingDiv: {
                ...prevState.videoDesignSettingDiv,
                is_dark: checked
            }
        }), () =>
        {
            this.props.onChangeSetting(this.state.videoDesignSettingDiv);
        })
    }
    onChangeHlsDelayValue = (e) =>
    {
        var time = e.currentTarget.value;

        this.setState(prevState => ({
            videoDesignSettingDiv: {
                ...prevState.videoDesignSettingDiv,
                hls_low_delay: time
            }
        }), () =>
        {
            this.props.onChangeSetting(this.state.videoDesignSettingDiv);
        })
    }
    onChangeVisitorTimeputValue = (e) =>
    {
        var time = e.currentTarget.value;

        this.setState(prevState => ({
            videoDesignSettingDiv: {
                ...prevState.videoDesignSettingDiv,
                visitor_timeout: time
            }
        }), () =>
        {
            this.props.onChangeSetting(this.state.videoDesignSettingDiv);
        })
    }
    render()
    {
        return <Fragment>
            <Drawer className={this.props.videoData.is_dark === true ? "darkModal drawer-content-wrapper p-0" : "drawer-content-wrapper p-0"}
                right
                width={550}
                open={this.state.openRight}
                onChange={open => {this.setState({ openRight: open }) }}
            >
                <div className="drawer-nav-btn" style={{ top: '10px' }}>
                    <Hamburger
                        active={true}
                        type="elastic"
                        onClick={this.props.onCloseDrawerClick}
                    />
                </div>
                <div className="drawer-heading font-size-lg text-capitalize font-weight-normal" >
                    <i className="header-icon lnr-pencil icon-gradient bg-malibu-beach"> </i>Video Settings
                                            </div>
                <div className="drawer-section">
                    <Row>
                        <Col>
                            <Fragment>
                                <FormGroup>
                                    <Label for="" className="d-block mb-3">Logo</Label>  &nbsp;
                                    <Switch checked={this.props.videoDesignSettingDiv.show_logo} onChange={this.onLogoChange} className="sm mr-2 mb-2" />
                                    <br />
                                    {this.props.videoDesignSettingDiv.show_logo === true ?null
                                        /*  <Fragment>
                                            <div className="mb-2">
                                                <Button className="mr-2" color="primary" onClick={this.handleUploadChannelLogo}>Upload Logo
                                                <input className="hidden" accept="image/*" ref={input => this.logoInputElement = input} type="file" id="channelLogo" name="channelLogoName" label="Upload a logo" onChange={this.handleVideoLogoChange} />
                                                </Button>
                                                <Button color="danger" onClick={this.handleCancelVideoLogoUpload}>Remove Logo</Button>
                                            </div>
                                            {this.props.videoDesignSettingDiv.logo_src !== "" ? <img width="150" src={this.props.videoDesignSettingDiv.logo_src} ref={iconImgRef => this.imgLogo = iconImgRef} alt="Video Logo" onError={this.onLogoImageError} /> : null}
                                        </Fragment> */
                                        : null}
                                </FormGroup>
                            </Fragment>
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col xl={6}>
                            <Label for="" className="d-block mb-3">Home Page</Label>  &nbsp;
                                      <Switch checked={this.props.videoDesignSettingDiv.show_homepage} onChange={this.onHomePageChange} className="sm mr-2 mb-2" />
                            <br />
                            {this.props.videoDesignSettingDiv.show_homepage === true ? <input type="text" style={{ width: "100%" }}
                                defaultValue={this.props.videoDesignSettingDiv.homepage_link}
                                value={this.state.videoDesignSettingDiv.homepage_link}
                                onChange={this.onHomePageTextChange} /> : null}
                        </Col>

                    </Row>
                    
                    {this.props.videoData.isYoutube !== true ? <fragmnet><hr /><label>Settings</label> <br /> <br /> </fragmnet> : null}
                    <Row>
                        {this.props.videoData.videoType === "2" ? <Col xl={12}>
                            <Label for="" className="d-block mb-3">Chat</Label>  &nbsp;
                                      <Switch checked={this.props.videoDesignSettingDiv.show_chat} onChange={this.onChatChange} className="sm mr-2 mb-2" />
                        </Col> : null}
                        {this.props.videoData.videoType === "2" ? <Col xl={6}>
                            <Label>HLS Low Delay</Label>
                            <input defaultValue={this.props.videoDesignSettingDiv.hls_low_delay} value={this.state.videoDesignSettingDiv.hls_low_delay} type="number" min="0" onChange={this.onChangeHlsDelayValue} />
                        </Col> : null}
                        {this.props.videoData.videoType === "2" ? <Col xl={6}>
                            <Label>Visitor TimeOut (in minutes)</Label>
                            <input defaultValue={this.props.videoData.visitor_timeout} value={this.state.videoDesignSettingDiv.visitor_timeout} type="number" min="0" onChange={this.onChangeVisitorTimeputValue} />
                        </Col> : null}
                        {this.props.videoData.videoType === "1" && this.props.videoData.isYoutube !== true ? <Col xl={6}>
                            <Label for="" className="d-block mb-3">References</Label>  &nbsp;
                                      <Switch checked={this.props.videoDesignSettingDiv.show_references} onChange={this.onReferncesChange} className="sm mr-2 mb-2" />
                        </Col> : null}
                        {this.props.videoData.videoType === "1" && this.props.videoData.isYoutube!==true ? <Col xl={6}>
                            <Label for="" className="d-block mb-3">Bookmarks</Label>  &nbsp;
                                      <Switch checked={this.props.videoDesignSettingDiv.show_bookmarks} onChange={this.onBookmarksChange} className="sm mr-2 mb-2" />
                        </Col> : null}
                        {this.props.videoData.videoType === "1" && this.props.videoData.isYoutube !== true ? <Col xl={6}>
                            <Label for="" className="d-block mb-3">Allow Download</Label>  &nbsp;
                                      <Switch checked={this.props.videoDesignSettingDiv.show_download} onChange={this.onDownloadChange} className="sm mr-2 mb-2" />
                        </Col> : null}
                    </Row>

                    <hr />
                    <label>Communication settings</label><br /><br />
                    <Row>

                        <Col xl={4}>
                            <Label for="" className="d-block mb-3">Comments</Label>  &nbsp;
                                      <Switch checked={this.props.videoDesignSettingDiv.show_comments} onChange={this.onCommentsChange} className="sm mr-2 mb-2" />
                        </Col>
                        <Col xl={4}>
                            <Label for="" className="d-block mb-3">Facebook Comments</Label>  &nbsp;
                                      <Switch checked={this.props.videoDesignSettingDiv.show_fb_comments} onChange={this.onFacebookCommentsChange} className="sm mr-2 mb-2" />
                        </Col>

                    </Row>

                    <hr />
                    <label>Theme settings</label><br /><br />
                    <Row>

                        <Col xl={4}>
                            <Label for="" className="d-block mb-3">Dark</Label>  &nbsp;
                                      <Switch checked={this.props.videoDesignSettingDiv.is_dark} onChange={this.onThemeChange} className="sm mr-2 mb-2" />
                        </Col>

                    </Row>
                    <Row>
                        <div style={{ textAlign: "right", width: "100%" }}>
                            <Button color="primary" onClick={this.onSaveVideoSettingsClick}>Save</Button>
                        </div>
                    </Row>
                </div>
            </Drawer>

        </Fragment>
    }
}